import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IReferralFormTemplate } from "../../shared/models/interfaces/referral-form-template";
import { FormsService } from "../forms.service";
import { FeedbackService } from "../../shared/services/feedback.service";

@Component({
  selector: "app-preview-form",
  templateUrl: "./preview-form.component.html",
  styleUrls: ["./preview-form.component.scss"],
})
export class PreviewFormComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  referralForm: IReferralFormTemplate;
  referralFormQuestionGroups: any;
  isLoading: boolean = false;
  constructor(
    private readonly formsService: FormsService,
    private feedbackService: FeedbackService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      const id = +params["id"];
      if (id) {
        this.formsService.getReferralFormById(id).pipe(
          takeUntil(this.destroy$)
        ).subscribe({
          next: (response) => {
            if (!response) {
              this.feedbackService.show("Unable to load form");
            }
            this.referralForm = response;
            this.referralFormQuestionGroups = response.referralFormQuestionGroups.sort(
              (a, b) => (a.index < b.index ? -1 : a.index > b.index ? 1 : 0)
            );
          },
          error: (error) => {
            this.feedbackService.error(error);
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
